import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { WorkflowV1 } from "../shared/interfaces/WorkflowV1";
import { WorkflowV2 } from "../shared/interfaces/WorkflowV2";

export function useWorkflowUpdate(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["updateWorkflow"],
    async (workflow: WorkflowV1 | WorkflowV2) => apiContext.workflowApis.updateWorkflow(workflow),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
